import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import { editRowPLACEHOLDER } from "../../../requests/tableRowActions/placeholderData";
import {
  isFetchingEditRow,
  receiveEditRow,
  updateTemplateBuilderEditRow,
} from "../actionCreators";
import { EditRowReducerState } from "../types";

const initialState: EditRowReducerState = {
  data: editRowPLACEHOLDER,
  isFetching: false,
};

const editRowReducer = reducer(
  initialState,
  on(receiveEditRow, (state, { payload: { editRow } }) => {
    // eslint-disable-next-line no-param-reassign
    state.data = { ...editRow };
  }),
  on(updateTemplateBuilderEditRow, (state, { payload: { newEditRow } }) => {
    // eslint-disable-next-line no-param-reassign
    state.data = { ...newEditRow };
  }),
  on(isFetchingEditRow, (state, { payload: { isFetching } }) => {
    // eslint-disable-next-line no-param-reassign
    state.isFetching = isFetching;
  })
);

export default editRowReducer;
